import {
  GetFrontTipiDomandaStato,
  GetTipiDomandaTipoPubblicazione,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import { yup } from '@framework/validation';
export const InquiryListSchema = yup
  .object({
    titolo: yup.string().label(t('inquiry.titolo', 'Titolo')),
    tipoUtenteDestinatario: yup
      .array(yup.string().required())
      .default(() => [])
      .label(t('inquiry.destinatari', 'Destinatari')),
    ambito: yup.string().allowNullable().label(t('inquiry.ambito', 'Ambito')),
    categorie: yup
      .array(yup.string().required())
      .default(() => [])
      .label(t('inquiry.categorie', 'Categorie')),
    soloAttive: yup
      .boolean()
      .allowNullable()
      .label(t('inquiry.solo-attive', 'Solo Attive')),
    // Di default facciamo una ricerca anche per sotto ambiti
    sottoAmbito: yup.boolean().label(t('inquiry.sotto-ambito', 'Sotto Ambito')),
    tipoPubblicazione: yup
      .string()
      .oneOfEnum(GetTipiDomandaTipoPubblicazione)
      .allowNullable()
      .label(t('inquiry.tipo-pubblicazione', 'Tipo Pubblicazione')),
    stato: yup
      .string()
      .oneOfEnum(GetFrontTipiDomandaStato)
      .allowNullable()
      .label(t('inquiry.stato', 'Stato')),
    codiceAOO: yup
      .string()
      .allowNullable()
      .label(t('inquiry.area-filter', 'Amministrazione')),
  })
  .noUnknown()
  .required();

export type InquirySchemaType = yup.InferType<typeof InquiryListSchema>;
